import React, { Component } from 'react';import PropTypes from 'prop-types';
import firebase from 'firebase';
import ImageUploader from 'react-firebase-file-uploader';
import LinearProgress from 'material-ui/LinearProgress';
import Delete from '../Buttons/Delete';
import Label from './Label';


const style = {

  container:
    {
      paddingBottom: "5px",
      borderBottom: "solid 1px #aaa",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },

  previewContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",    
  },
  image:
    {
      maxHeight: 75,
      marginRight: "1em", 
    }
}

class ImageField extends Component {

  constructor(props) {
    super(props);
    var val = this.props.value ? this.props.value : "";
    var url = this.props.url ? this.props.url : "";
    this.state = {
      value: val,
      isUploading: false,
      progress: 0,
      url: url,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    var val = nextProps.value ? nextProps.value : "";
    var url = nextProps.url ? nextProps.url : "";
    this.setState({
      value: val,
      isUploading: false,
      progress: 0,
      url: url,
    });
  }

  handleChange = (event) => {
    this.setState({
      value: event.target.value,
    });
  };

  
  handleUploadStart = () => this.setState({isUploading: true, progress: 0});
  handleProgress = (progress) => this.setState({progress});
  handleUploadError = (error) => {
    this.setState({isUploading: false});
    alert(error);
  }
  handleUploadSuccess = (value) => {
    this.setState({...this.state, value: value });
    firebase.storage().ref('images').child(value).getDownloadURL().then(this.handleUrl);
  };
  handleUrl = (url) => {
    this.setState({...this.state, progress: 0, isUploading: false, url: url});
  };

  handleDelete = (url) => {
    this.setState({...this.state, progress: 0, isUploading: false, url: ''});
  };

  render() {
    return (
      <div style={style.container}>
        <Label >{this.props.label}</Label>
        <div style={style.previewContainer}>
          {this.state.url && <img key={this.state.url} alt="" style={style.image} src={this.state.url} /> }

           <ImageUploader
           name="value"
           storageRef={firebase.storage().ref('images')}
           onUploadStart={this.handleUploadStart}
           onUploadError={this.handleUploadError}
           onUploadSuccess={this.handleUploadSuccess}
           onProgress={this.handleProgress}
           />
           {this.state.url && <Delete handleClick={this.handleDelete} />}

        </div>
        {this.state.isUploading && <LinearProgress mode="determinate" value={this.state.progress} />}
      </div>
    );
  }
}

export default ImageField;



// WEBPACK FOOTER //
// ./src/components/Form/ImageField.jsx